import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { QuizAnswers } from '@/features/quiz/types';

interface QuizState {
  currentStepIndex: number;
  answers: QuizAnswers;
  completed: boolean;
  variant: string;
  setStepIndex: (index: number) => void;
  setAnswer: (stepId: string, value: string | string[]) => void;
  setVariant: (variant: string) => void;
  complete: () => void;
  setCompleted: (completed: boolean) => void;
  reset: () => void;
}

export const useQuizStore = create<QuizState>()(
  persist(
    (set) => ({
      currentStepIndex: 0,
      answers: {},
      completed: false,
      variant: 'default',
      setStepIndex: (index) => set({ currentStepIndex: index }),
      setAnswer: (stepId, value) =>
        set((s) => ({ answers: { ...s.answers, [stepId]: value } })),
      setVariant: (variant) => set({ variant }),
      complete: () => set({ completed: true }),
      setCompleted: (completed) => set({ completed }),
      reset: () => set({ currentStepIndex: 0, answers: {}, completed: false }),
    }),
    {
      name: 'bp-quiz',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
